import React from 'react'
import PropTypes from 'prop-types'
import { PromotionRenderer } from 'LiveBoard/components/shared/Promotion'
import { SideBySideRenderer } from 'LiveBoard/components/shared/SideBySide'
import filter from 'lodash/filter'
import map from 'lodash/map'
import sortBy from 'lodash/sortBy'

const PositionRenderer = (props) => {

  const PROMOTION = "promotion"
  const SIDE_BY_SIDE = "sideBySide"

  const renderers = {
    [PROMOTION]: PromotionRenderer,
    [SIDE_BY_SIDE]: SideBySideRenderer
  }

  const fetchLayouts = (layouts, type) => {
    return filter(layouts, (layout) => {
      return layout.position.location == props.location
    }).map((layout) => {
      return {type: type, content: layout}
    })
  }

  const getSortedUnifiedLocationsArrays = () => {
    return sortBy([
        ...fetchLayouts(props.promotion, PROMOTION),
        ...fetchLayouts(props.sideBySide.areas, SIDE_BY_SIDE)
      ], (object) => {
      return object.content.position.value
    })
  }

  return map(getSortedUnifiedLocationsArrays(), (object, key) => {
    const SpecificRenderer = renderers[object.type]
    return <SpecificRenderer
              key={key}
              area={object.content}
              themeColorHex={props.themeColorHex}
              onItemClick={props.onItemClick}
              isMobile={props.isMobile}
              showPromotion={props.showPromotion} />
  })
}

PositionRenderer.propTypes = {
  sideBySide: PropTypes.object,
  promotion: PropTypes.object,
  location: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string,
  onItemClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  showPromotion: PropTypes.bool
}

export default PositionRenderer
